"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

export default function ScrollToTopHandler() {
    const pathname = usePathname();

    useEffect(() => {
        // Always scroll to top when pathname changes
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}
